import { useMemo } from "react";
import { useEntitiesFromDb } from "./use-entities-from-db";

export const useEntityByName = (entityName: string) => {
  const { allAvailableEntities } = useEntitiesFromDb();

  const entity = useMemo(() => {
    return allAvailableEntities?.find((x) => x?.name === entityName);
  }, [allAvailableEntities, entityName]);

  return { entity };
};
